<template>
   <div class="position-relative grey-banner">
      <div class="container-fluid container-lg">
         <div class="row d-none d-sm-flex">
            <div class="col-sm-4">
               <table>
                  <tbody>
                     <tr>
                        <td>
                           <img
                              src="/wp-content/themes/findforsikring_2015-sommer/images/graphics/landingpages/danmark.svg"
                              width="50"
                              height="60" />
                        </td>
                        <td>
                           <p>
                              Brugt af over
                              <br />
                              <b>{{ $store.state.stats.usedBy }}</b>
                           </p>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
            <div class="col-sm-4 text-center">
               <img
                  class="trust"
                  src="/wp-content/themes/findforsikring_2015-sommer/icons/rasmus-ikoner/fftrust.png"
                  width="150"
                  height="62" />
            </div>
            <div class="col-sm-4">
               <table class="float-right">
                  <tbody>
                     <tr>
                        <td>
                           <img
                              class="circle-wrap"
                              src="/wp-content/themes/findforsikring_2015-sommer/images/graphics/landingpages/gris.svg"
                              width="61"
                              height="60" />
                        </td>
                        <td>
                           <p>
                              Besparelse i snit
                              <br />
                              <b>{{ $store.state.stats.saved }},-</b>
                           </p>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
         <div class="row d-sm-none">
            <div class="col-12">
               <table style="margin: 0 auto">
                  <tbody>
                     <tr>
                        <td>
                           <img
                              src="/wp-content/themes/findforsikring_2015-sommer/images/graphics/landingpages/danmark.svg"
                              width="50"
                              height="60" />
                        </td>
                        <td>
                           <p>
                              Brugt af over
                              <br />
                              <b>{{ $store.state.stats.usedBy }}</b>
                           </p>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'GreyBannerSectionOld',
};
</script>

<style lang="scss" scoped>
.grey-banner {
   margin-bottom: 1px;
   padding: 2em 0;
   border-bottom: 1px solid #fff;
   background: linear-gradient(180deg, #fff 0, #e8e8e8);
   box-shadow: 0 1px 3px rgb(0 0 0 / 20%);
   td {
      > p {
         color: #293c4f;
         font-weight: 300;
         margin: 0;
         //font-style: italic;
         font-size: 16px;
         line-height: 1;
         > b {
            font-weight: 600;
            //font-style: italic;
            font-size: 32px;
         }
      }
      img {
         margin-right: 10px;
      }
      .circle-wrap {
         background: #9bcd79;
         background: linear-gradient(180deg, #9bcd79 0, #43ab6a 74%);
         filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#9bcd79",endColorstr="#43ab6a",GradientType=0);
         padding: 10px;
         border-radius: 50%;
      }
   }
}
.float-right {
   float: right;
}
</style>
